import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";

import Spinner from "../Spinner/Spinner";
import { Icon } from "../index";
import React from "react";

export interface ButtonProps {
  /**
   * Is this the principal call to action on the page?
   */
  primary?: boolean;
  /**
   * What background color to use
   */
  backgroundColor?: string;
  /**
   * How large should the button be?
   */
  size?: "small" | "medium" | "large";
  /**
   * Button contents
   */
  text: string;
  /**
   * Optional click handler
   */
  onClick?: (e?: any) => void;
  /**
   * What color should button be?
   */
  color: string;
  /**
   * What is the size of button?
   */
  width?: string;
  /**
   * Just For Story Book !
   */
  storyBookBg?: string;
  /**
   * Just For Story Book !
   */
  storyBookColor?: string;
  /**
   * Custom Style For Btn
   */
  customStyle?: string;

  disabled?: boolean;
  height?: string;
  isLoading?: boolean;
  spinColor?: "blue" | "white" | "black" | "bgPrimary" | "gray";
  icon?: {
    name: string;
    width: string;
    height: string;
  };
  direction?: "left" | "right";
  id?: string;
  type?: "submit" | "button";
  className?: string;
}

interface StyledButtonElementProps {
  color: string;
  backgroundColor: string;
  width?: string;
  size: string;
  primary: boolean;
  storyBookColor?: string;
  storyBookBg?: string;
  customStyle?: string;
  height?: string;
  direction?: string;
}

/**
 * Styled Css For Button
 */
const StyledButton = styled.button<StyledButtonElementProps>`
  border-radius: 8px;
  height: ${(p) => p.height || "40px"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: ${(p) => (p.direction ? "row-reverse" : "row")};
  color: ${(p) => (theme: any) => {
    return theme.theme[p.color] ? theme.theme[p.color] : p.storyBookColor;
  }};
  background-color: ${(p) => (theme: any) => {
    return theme.theme[p.backgroundColor]
      ? theme.theme[p.backgroundColor]
      : p.storyBookBg;
  }};
  border: none;
  opacity: ${(p) => (p.disabled ? "0.5" : "1")};
  width: ${(p) => p.width};
  ${(p) =>
    !p.primary &&
    css`
      color: #c2c2c2;
      background-color: transparent;
      box-shadow: rgba(0, 0, 0, 0.15) 0 0 0 1px inset; ;
    `};
  ${(p) =>
    p.size === "small" &&
    css`
      font-size: 12px;
      padding: 10px 16px;
    `}
  ${(p) =>
    p.size === "medium" &&
    css`
      font-size: 14px;
      padding: 4px 12px;
    `}
    ${(p) =>
    p.size === "large" &&
    css`
      font-size: 16px;
      padding: 12px 24px;
    `}
    ${(p) =>
    p.customStyle &&
    css`
      ${p.customStyle}
    `} /* &:hover {
      background-color: ${(theme) => theme.theme.bgPrimary} ?? blue;
    } */
`;
const SpinnerHolder = styled.div`
  position: relative;
  height: 40px;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const IconHolder = styled.div`
  margin: 0 5px;
`;
/**
 * Primary UI component for user interaction
 */
const Button: React.FC<ButtonProps> = ({
  primary = false,
  storyBookBg = "primary",
  storyBookColor = "primary",
  size = "medium",
  backgroundColor = "Light6",
  text,
  color,
  width,
  disabled,
  onClick,
  customStyle,
  spinColor = "white",
  isLoading = false,
  icon,
  direction,
  id,
  type = "submit",
  className = "",
  ...props
}) => {
  const { t } = useTranslation();
  /**
   * Handel On Click
   */
  const handelOnClick = () => {
    if (typeof onClick !== "undefined") {
      if (typeof isLoading !== "undefined" && !isLoading) {
        onClick();
      }
    }
  };
  /**
   * Rendering the main Atom
   */
  return (
    <StyledButton
      type={type}
      customStyle={customStyle}
      primary={primary}
      storyBookBg={storyBookBg}
      storyBookColor={storyBookColor}
      backgroundColor={backgroundColor}
      size={size}
      color={color === "white" ? "alwaysWhite" : color}
      width={width}
      onClick={handelOnClick}
      disabled={disabled}
      direction={direction}
      id={id}
      className={className}
    >
      {icon && (
        <IconHolder>
          <Icon name={icon.name} width={icon.width} height={icon.height} />
        </IconHolder>
      )}
      {isLoading ? (
        <SpinnerHolder data-testid="test-spinner">
          <span>{t("PLEASE_WAIT")}</span>
          <Spinner color={spinColor} />
        </SpinnerHolder>
      ) : (
        t(text)
      )}
    </StyledButton>
  );
};

export default Button;
